/**
 * Time Conversion Utilities
 * 
 * Functions for converting between milliseconds, seconds, and musical bars.
 */

/**
 * Convert milliseconds to seconds
 * 
 * @param {number} milliseconds - Time in milliseconds
 * @returns {number} Time in seconds
 */
export function millisecondsToSeconds(milliseconds) {
  return milliseconds / 1000;
}

/**
 * Calculate the duration of one bar in seconds
 * 
 * @param {number} bpm - Beats per minute (tempo)
 * @param {[number, number]} timeSignature - Time signature [numerator, denominator]
 * @returns {number} Duration of one bar in seconds
 * 
 * @example
 * calculateBarDuration(120, [4, 4]) // 2 seconds per bar at 120 BPM in 4/4
 */
export function calculateBarDuration(bpm, timeSignature) {
  const [numerator, denominator] = timeSignature;
  const beatsPerBar = numerator;
  const quarterNoteRatio = denominator / 4;
  
  return (60 / bpm) * beatsPerBar / quarterNoteRatio;
}

/**
 * Convert seconds to bar number
 * 
 * @param {number} seconds - Time position in seconds
 * @param {number} barDuration - Duration of one bar in seconds
 * @param {number} threshold - Rounding threshold for near-zero values
 * @returns {number} Bar number (0-indexed)
 */
export function secondsToBars(seconds, barDuration, threshold = 0.1) {
  const bars = seconds / barDuration;
  
  // Round to 0 if very close to start
  if (bars < threshold) {
    return 0;
  }
  
  return Math.round(bars);
}


